import { linker } from '@vlabs/api/point-api/client';

import { fetchFirstPageCardIds, PAGE_SIZE } from './shared';

export async function detachAllCardsFromList(listId: string): Promise<void> {
  while (true) {
    // eslint-disable-next-line no-await-in-loop
    const cardIds = await fetchFirstPageCardIds(listId);

    if (cardIds.length === 0) return;

    // eslint-disable-next-line no-await-in-loop
    await linker({
      action: 'detach',
      card_ids: cardIds,
      list_id: listId,
    });

    if (cardIds.length < PAGE_SIZE) return;
  }
}
